import { AccountMenu } from './AccountMenu';
import { CartButton } from './CartButton';
import { StorefrontMobileMenu } from './StorefrontMobileMenu';
import { useOnStorefront } from '../hooks/use-on-storefront';

/**
 * O `mobileSlot` da `Topbar` — o mesmo conjunto de ações do desktop, em dois
 * botões.
 *
 * **A sacola fica de fora do menu, e é a única que fica.** Ela é a ação
 * primária da vitrine; guardá-la atrás de um toque trocaria o problema de
 * espaço por um de conversão. O resto — pedidos, tela inicial, tema — cabe no
 * painel, onde vira linha de 44px com rótulo em vez de ícone de 36px sem.
 *
 * Fora da vitrine sobra só a conta, como no desktop: a mesma
 * `useOnStorefront` decide os dois. Na vitrine o "Sair" vive no painel.
 */
export function StorefrontMobileActions() {
  const naVitrine = useOnStorefront();
  if (!naVitrine) return <AccountMenu />;

  return (
    <>
      <CartButton />
      <StorefrontMobileMenu />
    </>
  );
}
